<template>
  <div class="column landing_portfolio">
    <div class="column">
      <div class="column component_card_border_bottom">
        <p class="p0">{{ $t("msg.portfolio_intro") }}</p>
      </div>
      <div class="column component_card_border_bottom p0">
        <div>
          <div class="block_1">
            <div
              class="dis_inb landing_portfolio_chart_item"
              v-for="(coin, index) in assetList"
              v-bind:key="coin.currency.name"
              @click="labelClick(coin.currency.symbol)"
              v-bind:class="{
                'landing_portfolio_chart_highlight ':
                  selectedCoin == coin.currency.symbol,
              }"
              v-if="coin.assignedOverallWeight > 0"
            >
              <span class="fat" :class="'color_' + coin.currency.symbol">{{
                coin.currency.name == 'TrueUSD' ? 'Tether' : coin.currency.name
              }}</span>
              <div
                class="landing_portfolio_icon dis_inb background_"
                :class="'background_' + coin.currency.symbol"
              ></div>
              <p class="tal_l landing_portfolio_labels">
                <span v-if="coin.currency.symbol != 'OTC'"
                  >{{ coin.currency.symbol == 'TUSD' ? 'USDT' : coin.currency.symbol }} |</span
                >
                {{ coin.assignedOverallWeight.toFixed(2) }}%
              </p>
            </div>
          </div>
          <div class="block_2">
            <canvas id="mainChart"></canvas>
          </div>
        </div>
      </div>
      <div class="column">
        <h1 class="title">
          <span
            class="landing_portfolio_icon dis_inb background_"
            :class="'background_' + selectedCoin"
          ></span>
          <span>{{ selectedCoin }}</span>
        </h1>
        <p class="text_md landing_portfolio_footer">
          {{ $t("msg.text_" + selectedCoin, 1) }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["assetList"],
  created() {
    let vm = this;
    setTimeout(function () {
      vm.setChartData();
    }, 300);
  },
  mounted() {},
  data: () => ({
    canvasData: "",
    selectedCoin: "BTC",
    colorsArray: [],
    assetsTailStage: [],
    chartLabels: [],
    chartData: [],
    chartSymbol: [],

    coinColors: [
      {
        symbol: "BTC",
        color: "#ff9a28",
      },
      {
        symbol: "ETH",
        color: "#6374bf",
      },
      {
        symbol: "LINK",
        color: "#2a5ada",
      },
      {
        symbol: "XRP",
        color: "black",
      },
      {
        symbol: "DASH",
        color: "#1c81bc",
      },
      {
        symbol: "MKR",
        color: "#17ab99",
      },
      {
        symbol: "BCH",
        color: "#86cb5c",
      },
      {
        symbol: "LTC",
        color: "#345d9d",
      },
      {
        symbol: "XLM",
        color: "#000000",
      },
      {
        symbol: "ADA",
        color: "#0f9fff",
      },
      {
        symbol: "EOS",
        color: "#807979",
      },
      {
        symbol: "DOT",
        color: "#e6007a",
      },
      {
        symbol: "LEND",
        color: "#149aca",
      },
      {
        symbol: "AAVE",
        color: "rgba(182,80,158,1)",
      },
      {
        symbol: "BNB",
        color: "#f2c353",
      },

      {
        symbol: "UNI",
        color: "#ff0179",
      },
      {
        symbol: "FIL",
        color: "rgba(182,80,158,1)",
      },
      {
        symbol: "THETA",
        color: "#f2c353",
      },

      {
        symbol: "LUNA",
        color: "#172852",
      },

      {
        symbol: "MANA",
        color: "#ff3955",
      },

      //out
      {
        symbol: "ALGO",
        color: "black",
      },
      {
        symbol: "XMR",
        color: "#FF6501",
      },
      {
        symbol: "CAKE",
        color: "#d1884f",
      },
      {
        symbol: "SOL",
        color: "#62b9c4",
      },
      {
        symbol: "MATIC",
        color: "#9767e9",
      },
      {
        symbol: "CRV",
        color: "#c71a16",
      },
      {
        symbol: "AVAX",
        color: "#E84142",
      },
      {
        symbol: "MBOX",
        color: "#1b53f5",
      },
      {
        symbol: "USDT",
        color: "#57ae96",
      },
      {
        symbol: "TUSD",
        color: "#57ae96",
      },
    ],

    colorsArray: [],
  }),
  components: {},
  methods: {
    sortCurrenciesByPercentage() {
      this.currencies.sort((a, b) => {
        if (a.marketPercent < b.marketPercent) return 1;
        if (a.marketPercent > b.marketPercent) return -1;
        return 0;
      });
    },

    getPriceBySymbol(symb) {
      let coinPrice = this.currencies.filter((coin) => {
        return coin.symbol == symb;
      });

      return parseFloat(coinPrice[0].value);
    },

    labelClick(value) {
      this.selectedCoin = value;
    },

    bodyClick(e, value) {
      if (value[0]) {
        this.selectedCoin = value[0]._model.label == 'USDT' ? 'TUSD' : value[0]._model.label ;
      }
    },


    fixSymb(el){
      if(el == 'TUSD' || el == 'tusd'){
        return 'USDT';
      }else{
        return el;
      }
    },

    setChartData() {
      let functionArray = this.assetList;
      let obj;

      for (obj in functionArray) {
        this.chartLabels.push(this.fixSymb(functionArray[obj].currency.symbol));
        this.chartData.push(functionArray[obj].assignedOverallWeight);
        this.chartSymbol.push(this.fixSymb(functionArray[obj].currency.symbol));

      
        let selectedColor = this.coinColors.find(function (element) {
          return element.symbol == functionArray[obj].currency.symbol;
        });

        if(selectedColor){
          this.colorsArray.push(selectedColor.color);
        }
        
      }
      this.setUpChart();
    },

    setUpChart() {
      let chartData = {
        type: "pie",
        legendText: "aa",
        legend: {
          cursor: "pointer",
        },
        data: {
          labels: this.chartLabels,
          datasets: [
            {
              data: this.chartData,
              backgroundColor: this.colorsArray,
              fill: true,
              borderWidth: 0,
              lineTension: 0,
            },
          ],
        },
        options: {
          onHover: this.bodyClick,
          tooltips: {
            enabled: true,
            backgroundColor: "rgba(0,0,0,0.7)",
          },
          elements: {
            arc: {},
          },
          legend: {
            display: false,
          },
          plugins: {
            datalabels: {
              formatter: function (value, context) {
                return context.chart.data.labels[context.dataIndex];
              },
            },
          },
        },
      };

      this.createChart("mainChart", chartData);
    },
    createChart(chartId, chartData) {
      setTimeout(() => {
        const ctx = document.getElementById(chartId);
        const nasChart = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
      }, 100);
    },
  },
  computed: {
    ...mapGetters(["currencies"]),
  },
  watch: {},
};
</script>
<style lang="css">
.coin_bar {
  width: 100%;
  height: 10px;
  background-color: rgb(209, 204, 204);
}
.coin_bar_filled {
  background-color: #2f3577;
  display: block;
  height: 10px;
}
.percent24 {
  color: green;
}
.is- {
  color: red;
}
.landing_portfolio_icon {
  width: 40px !important;
  height: 40px !important;
  display: inline-block;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/private/landing/LandingPortfolio.vue